import type { GridRowSelectionModel } from '@cognite/cogs-lab';
import { MissingChecklistsState } from '@infield/providers/checklist-scheduler-provider/types';
import { atom } from 'jotai';

export const checklistCreationStateAtom = atom<MissingChecklistsState>(
  MissingChecklistsState.NONE
);

export const schedulesDataGridSelectedRowsAtom = atom<GridRowSelectionModel>(
  []
);

export const checklistCreationProgressPercentAtom = atom<number>(0);
